import axios from 'axios'

export interface SignupRequestPayload {
  tenant_id?: string
  full_name: string
  email: string
  phone?: string
  role_requested?: string
  business_name?: string
  message?: string
}

const API_BASE = `${import.meta.env.VITE_API_BASE_URL ?? ''}/accounts/signup-requests`

export const submitSignupRequest = async (payload: SignupRequestPayload) => {
  const response = await axios.post(API_BASE, payload)
  return response.data
}
